import React from "react";

const ContentManagement = React.lazy(() => import("./content-management"));

export {
  ContentManagement,
};

